import {FC} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {rememberLoginReturn} from '../../auth/core/loginReturn'

/** /ticket without a sign-in: after signing in, the new ticket opens with the request this address names. */
const NewTicketPublic: FC = () => {
  const location = useLocation()
  return (
    <div className='container py-20' dir='rtl'>
      <div className='card mw-650px mx-auto'>
        <div className='card-body text-center p-10'>
          <i className='bi bi-shield-lock fs-2x text-primary mb-5 d-block' aria-hidden='true' />
          <h1 className='fs-2 mb-4'>ثبت امن درخواست پشتیبانی</h1>
          <p className='text-muted mb-7'>
            برای ثبت و پیگیری تیکت، ابتدا وارد حساب کاربری خود شوید. این الزام از اطلاعات شرکت و
            فایل‌های شما محافظت می‌کند.
          </p>
          <Link
            className='btn btn-primary'
            to='/auth/login'
            onClick={() => rememberLoginReturn(`/apps/ticket-management/new${location.search}`)}
          >
            ورود به حساب کاربری
          </Link>
        </div>
      </div>
    </div>
  )
}

export {NewTicketPublic}
